import { isTechnicianSeat, } from './permissions.js';
/** Operational access never opens the full company sections. */
export const TECHNICIAN_RESOURCES = {
    products: {
        read: 'canReadWorkReportProducts',
        write: 'canCreateWorkReportProducts',
    },
    customers: {
        read: 'canAccessWorkReports',
        write: 'canCreateWorkReportCustomers',
    },
    machines: { read: 'canAccessMachines', write: 'canWriteWorkReportMachines' },
    checks: {
        read: 'canReadWorkReportChecks',
        write: 'canWriteWorkReportChecks',
    },
    attachments: {
        read: 'canReadWorkReportAttachments',
        write: 'canWriteWorkReportAttachments',
    },
    contracts: { read: 'canReadWorkReportContracts' },
    deliveryNotes: { read: 'canReadWorkReportDeliveryNotes' },
};
export function canUseTechnicianResource(subject, resource, write = false) {
    if (!isTechnicianSeat(subject)) {
        if (resource === 'products')
            return (subject.role === 'OWNER' ||
                (subject.flags.canAccessProducts === true &&
                    (!write || subject.flags.canWrite === true)));
        return true;
    }
    const config = TECHNICIAN_RESOURCES[resource];
    return (subject.flags[config.read] === true &&
        (!write || (!!config.write && subject.flags[config.write] === true)));
}
export function readsOnlyOwnWorkReports(subject) {
    return (isTechnicianSeat(subject) && subject.flags.canReadAllWorkReports !== true);
}
//# sourceMappingURL=technician-permissions.js.map